<!--    
@description 动态增减表格
@author libaiqi
@date 2018/11/13
@version v1.1.0

/**** props ****/
// 表单元素配置
inputData: [
  {
    label: String,
    key: String,
    type: (原生input type: text（默认）/ rangeInput(范围输入) / select / rangeSelect(范围选择)),
    hidden: true/false,
    diable: true/false,
    select: {

    }
  }
],
// 数据
model: '',
// 增加回调
addFun: Function,
// 自定义回调
customFun: Function,
// 增加文案
addLabel: String,
// 自定义文案（默认'删除'）
customLabel: String
/**** commponent ****/
//组件操作按钮
默认有删除按钮
如有其他操作需求，可参考告警策略的新增/修改告警的使用，注：tData(必须)：为动态表格数据
 <dynamic-table ref="dynamicTable" :input-data="tableDatas" :model="tableModels" :add-fun="setOperation" :custom-fun="setOperation">
    <el-button  
        :slot="'operation'+index" 
        v-for="(item,index) in tData" 
        :key="index"
        @click="addTreatProcess(item,index)">
        其他操作
    </el-button>
</dynamic-table>
-->
<template>
    <div class="dynamicTable__block">
        <table class="dynamicTable__table">
            <thead>
                <tr>
                    <th class="dynamicTable__th" v-for="(item,index) in inputData" :key="index">{{item.label}}</th>
                    <th class="dynamicTable__th--none" v-show="isAdd">
                        <el-button type="primary" @click="e_addTable">{{addLabel}}</el-button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(data,dataIndex) in tableData" :key="dataIndex">
                    <td class="dynamicTable__td" v-for="(item,index) in inputData" :key="index">
                        <div v-if="item.type == 'select'">
                            <el-select  v-model="data[item.key]" :disabled="item.disabled ? item.disabled : false" @change="changeFun(data,dataIndex)">
                                <el-option
                                    v-for="(sitem, skey) in item.select"
                                    :key="skey"
                                    :label="sitem"
                                    :value="skey"
                                    >
                                </el-option>
                            </el-select>
                        </div>  
                        <div v-else-if="item.type == 'rangeSelect'" class="dynamicTable__rangeSelect">
                            <el-select class="dynamicTable__select--ilb" v-model="data[item.fkey]" :disabled="item.disabled ? item.disabled : false" >
                                <el-option
                                    v-for="(sitem, skey) in item.select"
                                    :key="skey"
                                    :label="sitem"
                                    :value="skey">
                                </el-option>
                            </el-select>
                            <span>{{$t('common.to')}}</span>
                            <el-select class="dynamicTable__select--ilb" v-model="data[item.skey]" :disabled="item.disabled ? item.disabled : false" >
                                <el-option
                                    v-for="(sitem, skey) in item.select"
                                    :key="skey"
                                    :label="sitem"
                                    :value="skey">
                                </el-option>
                            </el-select>
                        </div>
                        <div v-else-if="item.type == 'rangeInput'" class="dynamicTable__rangeInput">
                            <el-input class="dynamicTable__input--ilb" v-model="data[item.fkey]"
                                :disabled="item.disabled ? item.disabled : false" 
                            ></el-input>
                            <span>{{$t('common.to')}}</span>
                            <el-input class="dynamicTable__input--ilb" v-model="data[item.skey]"
                                :disabled="item.disabled ? item.disabled : false" 
                            ></el-input>
                        </div>
                        <div v-else-if="item.type == 'checkboxGroup'" class="dynamicTable__checkboxGroup">
                            <el-checkbox-group 
                                v-model="data[item.key]">
                                <el-checkbox v-for="(sitem, skey) in item.select" :label="skey" :key="skey" class="dynamicTable__checkItem">{{sitem}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-else-if="item.type == 'radio'">
                            <el-radio-group 
                                v-model="data[item.key]">
                                <el-radio :label="skey" v-for="(sitem, skey) in item.select" :key="skey">{{sitem}}</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-else-if="item.type == 'text'" class="dynamicTable__text" v-text="data[item.key]" :title="data[item.key]">
                        </div>
                        <div v-else>
                            <el-input  v-model="data[item.key]"
                                :disabled="item.disabled ? item.disabled : false" 
                            ></el-input>
                        </div>
                    </td>    
                    <td class="dynamicTable__th--none" v-show="isOperation">
                        <div class="dynamicTable__operation">
                            <slot :name="'operation' + dataIndex"></slot>
                            <el-button type="primary" @click="e_customFun(data,dataIndex)">{{customLabel}}</el-button>
                        </div>    
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
  import { extend } from '@/utils/tool'
  export default {
    data () {
      return {
        tableData: []
      }
    },
    computed: {
    },
    props: {
      inputData: {
        type: Array,
        required: true
      },
      model: {
        type: Object,
        required: true
      },
      addFun: {
        type: Function,
        default: null
      },
      customFun: {
        type: Function,
        default: null
      },
      customLabel: {
        type: String,
        default () {
          return this.$t('common.delete')
        }
      },
      addLabel: {
        type: String,
        default () {
          return this.$t('common.add')
        }
      },
      isAdd: {
        default: true,
        type: Boolean
      },
      isOperation: {
        default: true,
        type: Boolean
      }
    },
    methods: {
      e_addTable () {
        let newData = extend(true, {}, this.model)
        this.tableData.push(newData)
        this.addFun && this.addFun(extend(true, [], this.tableData))
      },
      e_customFun (item, i) {
        // this.tableData.splice(i, 1)
        this.customFun && this.customFun(item, i)
      },
      getData () {
        let data = extend(true, [], this.tableData)
        return data
      },
      setData (data) {
        this.tableData = extend(true, [], data)
      },
      changeFun (item, index) {
        this.$emit('selectChange', {
          item: item,
          index: index
        })
      }
    }
  }
</script>

<style scoped>
   .dynamicTable__block .dynamicTable__table {
        display: inline-table;
        border-collapse: collapse;
        vertical-align: middle;
        font-size: 14px;
    }
    .dynamicTable__block .dynamicTable__th {
        height: 30px;
        min-width: 90px;
        padding-left: 8px;
        border: 1px solid #ddd;
        text-align: left;
        
    }
    .dynamicTable__block .dynamicTable__th--none {
        border: none;
        padding-left: 5px;
    }
    .dynamicTable__block .dynamicTable__td {
        padding-left: 0px;
        text-align: center;
        border: 1px solid #ddd;
        max-width:200px;
    }
    .dynamicTable__block .dynamicTable__select--ilb,.dynamicTable__block .dynamicTable__input--ilb {
        display: inline-block;
        width: 42.5%;
    }
    .dynamicTable__block .dynamicTable__rangeSelect, .dynamicTable__block .dynamicTable__rangeInput{
        min-width: 150px;
    }
    .dynamicTable__block .dynamicTable__operation {
        display: flex;
    }
    .dynamicTable__text {
        padding: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }
    .dynamicTable__block .dynamicTable__checkItem {
        margin-left: 0;
    }
    .dynamicTable__block .dynamicTable__checkItem .el-checkbox__label{
        padding-left: 0;
        padding-right: 10px;
    }
</style>
  